import React from "react";
import { Box } from "@chakra-ui/react";

export function SigninSuccess() {
  return (
    <Box 
      color='#B5BAC1' px={5} py={3} 
      bg='#313338' borderRadius={10} 
      fontSize='lg' fontWeight='semibold'
    >
      Signin success!
    </Box>
  )
}